module.exports = __webpack_public_path__ + "static/media/Eric Ferrebee Headshot.b4bcd57a.jpeg";